import { bindActionCreators } from 'redux';
import { fetchStandardPage } from '../../redux/standardPage/actions';
import { setCurrentPathName } from '../../redux/app/actions';

export default (dispatch) => ({
  ...bindActionCreators(
    {
      fetchStandardPage,
      setCurrentPathName,
    },
    dispatch,
  ),
});
